/**
 * 线上环境
 */
export const ONLINEHOST = 'https://sjfadmin.emof.cn'
// export const ONLINEHOST = 'http://zcapi.emof.cn'

/**
 * 测试环境
 */
export const QAHOST = 'https://sjfadmin.emof.cn'
// export const QAHOST = 'http://192.168.1.23:8107'
// export const QAHOST = 'http://sjfadmin.emof.cn'

//文件地址
export const FILE_PATH_QN = `https://zchfile.emof.cn`
export const FILE_UPLOAD_HOST_QN = 'https://upload-z1.qiniup.com'
/**
 * 测试环境
 */
// export const QAHOST = 'http://192.168.2.250:8015'
export const upFeil = process.env.NODE_ENV === 'production' ? ONLINEHOST : QAHOST


/*
* 缓存字段
* */
export const localAnStore = [
    {
        key: 'user',
        type: 'localStorage'
    },
    {
        key: 'token',
        type: 'localStorage'
    },
    {
        key: 'server',
        type: 'localStorage'
    }
]
